var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"notification-bell",class:_vm.classes},[_c('div',{staticClass:"bell-icon"},[_c('BnIcon',{staticClass:"bell-icon__icon",attrs:{"name":_vm.icons.bell,"type":"'filled'"}}),(_vm.showIndicator)?_c('div',{staticClass:"bell-icon__indicator bell-indicator"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }